import {TextContentModel} from '../models/text.content-model';

export const KeywordsContentResources = {
    'keywords.start-for-free-now': new TextContentModel(
        {'fr': 'Débutez en ligne maintenant', 'en': 'Start online now'},
    ),
};
